import React from 'react';
import Icon from '../../../components/AppIcon';

const TableOfContents = ({ sections, activeSection, onSectionClick }) => {
  return (
    <div className="sticky top-24">
      <div className="bg-card border border-border rounded-xl p-4">
        <h3 className="text-sm font-semibold text-foreground mb-4 flex items-center">
          <Icon name="List" size={16} className="mr-2" />
          Table of Contents
        </h3>
        <nav className="space-y-1">
          {sections?.map((section) => (
            <button
              key={section?.id}
              onClick={() => onSectionClick?.(section?.id)}
              className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                activeSection === section?.id
                  ? 'bg-primary/10 text-primary font-medium' :'text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
            >
              {section?.title}
            </button>
          ))}
        </nav>
      </div>

      {/* Quick Contact Card */}
      <div className="bg-card border border-border rounded-xl p-4 mt-4">
        <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center">
          <Icon name="HelpCircle" size={16} className="mr-2" />
          Questions?
        </h3>
        <p className="text-xs text-muted-foreground mb-3">
          Have privacy concerns or questions about your data?
        </p>
        <a
          href="mailto:success@entrepreneurpowernetwork.com"
          className="text-xs text-primary hover:underline flex items-center"
        >
          Contact Us
          <Icon name="ArrowRight" size={12} className="ml-1" />
        </a>
      </div>
    </div>
  );
};

export default TableOfContents;